var RegisterLogin = function() {
    var login = function() {
        var username = $('#username_login').val();
        var password = $('#password_login').val();
        var action = '';
        var friend_id = '';
        if (username == '' || password == '') {
            return;
        }
        UserDataValidation.hideLoginPrompt();
        var login_form = $('#login_form');
        // login with action
        // (e.g. unregistered user, logs in to accept friend during blindchat)
        if (login_form.data('in_blindchat') === true) {
            action = login_form.data('action'); // action is either 'add' or 'accept'
            friend_id = login_form.data('uid');
        }
        $('#login_btn').prop('disabled', true);
        Ajax.login(username, password, action, friend_id, function(res) {
            if (res == 'ok') {
                if (Common.serving_app && $('#login_btn').hasClass('ii__payment')) {
                    MobileApp.message('premium');
                }
                window.location.href = '/home';
            } else {
                $('#login_btn').prop('disabled', false);
                UserDataValidation.showLoginPrompt();
            }
        });
    };

    var register = function(data) {
        var register_form = $('#register_form');

        // registration with prefs/action
        // (e.g. unregistered user, creates account to accept friend during blindchat)
        if (register_form.data('in_blindchat') === true) {
            data['action'] = register_form.data('action'); // action can be ['add', 'accept', 'migrate']
            data['friend_id'] = register_form.data('uid');

            var cookiePrefs = Common.jsCookies.getItem('BC2__PREFS');
            try {
                cookiePrefs = JSON.parse(cookiePrefs);
            } catch (e) {
                cookiePrefs = false;
            }
            if (cookiePrefs) {
                if (cookiePrefs.me != '' &&
                    cookiePrefs.seeking != '') {
                    data['gender'] = cookiePrefs.me;
                    data['gender_seeking'] = cookiePrefs.seeking;
                }
                if (cookiePrefs.age) {
                    data['age'] = cookiePrefs.age;
                }
                if (cookiePrefs.seeking_age_from) {
                    data['seeking_age_from'] = cookiePrefs.seeking_age_from;
                }
                if (cookiePrefs.seeking_age_to) {
                    data['seeking_age_to'] = cookiePrefs.seeking_age_to;
                }
                if (cookiePrefs.area) {
                    data['area'] = cookiePrefs.area;
                }
            }
        } else {
            if ($('#gender_seeking_combo').length == 1 &&
                $('#gender_seeking_combo').data('selected') == 'mf') {
                data['gender'] = 'male';
                data['gender_seeking'] = 'female';
            } else if ($('#gender_seeking_combo').length == 1 &&
                       $('#gender_seeking_combo').data('selected') == 'fm') {
                data['gender'] = 'female';
                data['gender_seeking'] = 'male';
            } else {
                $('#gender_seeking_btn').addClass('error');
                $('#register_btn').prop('disabled', false);
                return;
            }
        }
        Ajax.register(data, function(res) {
            if (res.success == 'ok') {
                if (Common.serving_app && $('#register_btn').hasClass('ii__payment')) {
                    MobileApp.message('premium');
                }
                window.location.href = data['action'] == 'history' ? '/history' : '/home';
                return;
            }
            // failed
            $('#register_btn').prop('disabled', false);
            switch (res.reason) {
            case 'username':
                UserDataValidation.showUsernameErrorPrompts('server');
                break;
            case 'pwd':
                UserDataValidation.showPasswordErrorPrompt('invalid');
                break;
            case 'email':
                UserDataValidation.showEmailErrorPrompt();
                break;
            case 'optin':
                $('#optin_container').addClass('error');
                break;
            default:
                Modal.showAlertModal('Η δημιουργία προφίλ απέτυχε');
                break;
            }
        });
    };

    return {
        init: function() {
            UserDataValidation.init(false);

            if (window.location.hash == '#register') {
                $('#register-tab').tab('show');
            }

            $('#login_btn').click(function() {
                login();
            });

            $('.ii__login_data_container input').keyup(function(ev) {
                if (ev.which == 13) {
                    login();
                }
            });

            $('#password').on('input blur', function() {
                UserDataValidation.hidePasswordPrompts();
                UserDataValidation.checkPwd($(this).val(), false);
            });

            $('#register_btn').click(function() {
                // user ignored username/email error prompts
                if ($('#username_container').hasClass('error') || $('#email_container').hasClass('error')) {
                    return;
                }
                // hide prompts
                UserDataValidation.hideUsernameErrorPrompts();
                UserDataValidation.hidePasswordPrompts();
                UserDataValidation.hideEmailErrorPrompt();
                $('#optin_container').removeClass('error');

                var data = {
                    username: $('#username').val(),
                    password: $('#password').val(),
                    email: $('#email').val(),
                    optin: $('#optin').prop('checked') ? '1' : '0'
                };

                if (!UserDataValidation.checkPwd(data['password'], false)) {
                    return;
                }
                if (!UserDataValidation.checkEmail(data['email'])) {
                    UserDataValidation.showEmailErrorPrompt();
                    return;
                }
                if (data['optin'] != '1') {
                    $('#optin_container').addClass('error');
                    return;
                }

                $('#register_btn').prop('disabled', true);

                // another username check before register(), in case the user
                // clicked 'save' with #username still in focus
                Ajax.checkUsername(data['username'], function(res) {
                    if (res.success != 'ok') {
                        $('#register_btn').prop('disabled', false);
                        UserDataValidation.showUsernameErrorPrompts(res.reason);
                        return;
                    }
                    register(data);
                });
            });
        }
    };
}();
